import React from 'react';
import { initials, TeamMember } from './helpers';
import { ensureIdentityStyles } from './styles';

// `avatarVersion === null` means the participant has no uploaded avatar, so
// `src` is the generic {id % 5} default and initials are the better rendering:
// ~23,500 people share each of the five defaults, whereas initials are personal.
// `undefined` means the caller predates the field — keep the old behaviour and
// show whatever src it gave us.
function face(name?: string | null, src?: string | null, avatarVersion?: string | null) {
  const showImage = !!src && avatarVersion !== null;
  return [
    showImage ? <img key="i" className="ac-av-img" src={src as string} alt={name || ''} onError={(e) => (e.currentTarget as HTMLImageElement).remove()} /> : null,
    <span key="f" className="ac-av-fallback">{initials(name)}</span>,
  ];
}

export function Avatar({ name, src, avatarVersion }: { name?: string | null; src?: string | null; avatarVersion?: string | null }) {
  React.useEffect(() => { ensureIdentityStyles(); }, []);
  return <div className="ac-avatar">{face(name, src, avatarVersion)}</div>;
}

export function AvatarStack({ members, max = 3, total }: { members: TeamMember[]; max?: number; total?: number }) {
  React.useEffect(() => { ensureIdentityStyles(); }, []);
  const shown = members.slice(0, max);
  const count = total != null ? total : members.length;
  const extra = count - shown.length;
  return (
    <div className="ac-avstack" title={members.map((m) => m.name).join(', ')}>
      {shown.map((m, i) => {
        const inner = face(m.name, m.avatarUrl, m.avatarVersion);
        return m.profileUrl
          ? <a key={(m.name || '') + i} className="ac-avatar" href={m.profileUrl} title={m.name || ''}>{inner}</a>
          : <div key={(m.name || '') + i} className="ac-avatar">{inner}</div>;
      })}
      {extra > 0 && <div className="ac-avmore">+{extra}</div>}
    </div>
  );
}
